// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(253, 246, 236, 0.92);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: loader-fade-in 0.15s ease;
}

@keyframes loader-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.loader-content {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Spinning ring */
.loader-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  padding: 3px;
  background: conic-gradient(
    from 0deg,
    var(--gold) 0%,
    var(--orange) 40%,
    transparent 60%
  );
  animation: loader-spin 0.9s linear infinite;
}

.loader-ring-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--cream);
}

/* Logo in centre */
.loader-logo {
  position: relative;
  width: 54px;
  height: 54px;
  object-fit: contain;
  z-index: 1;
  animation: loader-pulse 0.9s ease-in-out infinite;
  filter: drop-shadow(0 2px 8px rgba(200, 134, 10, 0.35));
}

@keyframes loader-spin {
  to { transform: rotate(360deg); }
}

@keyframes loader-pulse {
  0%, 100% { transform: scale(1);    opacity: 1; }
  50%       { transform: scale(0.88); opacity: 0.7; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PageLoader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ;;;;;GAKC;EACD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,iDAAiD;EACjD,uDAAuD;AACzD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,mBAAmB,KAAK,UAAU,EAAE;EAC/C,YAAY,sBAAsB,EAAE,YAAY,EAAE;AACpD","sourcesContent":[".page-loader {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(253, 246, 236, 0.92);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: loader-fade-in 0.15s ease;\n}\n\n@keyframes loader-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.loader-content {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Spinning ring */\n.loader-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  padding: 3px;\n  background: conic-gradient(\n    from 0deg,\n    var(--gold) 0%,\n    var(--orange) 40%,\n    transparent 60%\n  );\n  animation: loader-spin 0.9s linear infinite;\n}\n\n.loader-ring-inner {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: var(--cream);\n}\n\n/* Logo in centre */\n.loader-logo {\n  position: relative;\n  width: 54px;\n  height: 54px;\n  object-fit: contain;\n  z-index: 1;\n  animation: loader-pulse 0.9s ease-in-out infinite;\n  filter: drop-shadow(0 2px 8px rgba(200, 134, 10, 0.35));\n}\n\n@keyframes loader-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes loader-pulse {\n  0%, 100% { transform: scale(1);    opacity: 1; }\n  50%       { transform: scale(0.88); opacity: 0.7; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
